import { CdkDragDrop, CdkDragMove, CdkDragStart, copyArrayItem, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectorRef } from '@angular/core';

import { BaseServiceService } from 'src/app/services/base-service.service';
import { ConfigWindow } from 'src/app/models/config-window';
import { FormActionsThroughEmitters } from 'src/app/models/general.enum';
import { GeneralComunicationService } from 'src/app/services/general-comunication.service';
import { HelperImages } from 'src/app/helpers/helper-images';
import { List } from '../../../../assets/linqts/compilado/index';
import { StaticData } from 'src/app/helpers/static-data';
import { Subject } from 'rxjs';
import { Utilities } from 'src/app/helpers/utilities';

@Component({
  selector: 'app-drag-and-dop-metadata',
  templateUrl: './drag-and-dop-metadata.component.html',
  styleUrls: ['./drag-and-dop-metadata.component.scss']
})

export class DragAndDopMetadataComponent implements OnInit, OnDestroy {

  static CacheMetadatos: any = {};

  @Output() onInitialized = new EventEmitter<any>();
  @Input() public parentClearCall: Subject<any>;
  @Input() public parentCallRefresh: Subject<any>;
  @Input() isModelContainer: boolean = false;
  @Output() onActionEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() config: any;
  @Input() QueryConfig: any;
  _modelo: any;
  @Input() set modelo(value: any) {
    if (this.selectedItems && this.selectedItems.length > 0 && value) {
      console.warn("🛡️ [ESCUDO] Protegiendo datos locales tras recarga del padre.");
      let innerValue = value.modelo ? value.modelo : value;
      this._SetConfiguracion(innerValue);
    }

    this._modelo = value;
    
    if (this.isInit) {
      this.SincronizarVista();
    }
  }

  private SincronizarVista() {
    setTimeout(() => {
      if (this.cdr && !(this.cdr as any).destroyed) {
        this.SetModelo(this._modelo);
      }
    }, 200); 
  }

  get modelo(): any {

    return this._modelo;

  }

  @Input() propConfiguracionInterna: string = 'Metadatos';
  @Input() propConfiguracion: string = 'Configuracion';
  @Input() componentName: string = 'DragAndDopMetadataComponent';
  @Input() name: string = 'DragAndDopMetadataComponent';
  @Input() url: string = '';
  @Input() processMessage: string = 'Cargando metadatos...';

  @Input() pkField: string = 'Id';
  @Input() textField: string = '';
  @Input() loadOnInit: boolean = true;
  @Input() listName: string = "drop-list-metadata";
  @Input() listToConnect: Array<any> = ['drop-list-form', 'drop-list-extra', 'drop-list-meta', 'drop-list-list', 'drop-list'];
  @Input() label: string = 'dsadsdsad';
  isInit: boolean = false;
  isUpdatingParent: boolean = false;

  allSelectionItems: Array<any> = [];
  userControls: Array<any> = [];
  selectionItems: Array<any> = [];
  selectedItems: Array<any> = [];
  deltetedItems: Array<any> = [];
  addItems: Array<any> = [];

  Estilos: any;
  public direction: string = 'horizontal';
  public directionOrgCharts: string = 'vertical';
  public directionGrid: string = 'horizontal';
  EstiloBuscarContenedor: any = { height: "600px" };

  @Input() Hidden: boolean = false;
  @Input() Disabled: boolean = false;

  constructor(public baseService: BaseServiceService, public utility: Utilities, public helperImages: HelperImages, public comunicationService: GeneralComunicationService, private cdr: ChangeDetectorRef) { }

  //* FUNCIONES ANGULAR

  ngOnDestroy(): void {

    this.utility.Unsubscribe(this.parentClearCall);
    this.utility.Unsubscribe(this.parentCallRefresh);

  }

  ngOnInit() {
    this.Estilos = StaticData.Estilos;
    this.isInit = true;
    this.allSelectionItems = this.utility.Clone(StaticData.ToolBox.UserControls.filter(item => item.Activo == true));
    this.selectionItems = this.utility.Clone(StaticData.ToolBox.UserControls.filter(item => item.Activo == true));
    this.OnSetConfig();
    this.OnInit();

    // SI EL MODELO YA EXISTE, LO CARGAMOS
    if (this._modelo) {
      this.SincronizarVista();
    }

    if (this.parentClearCall){
      this.parentClearCall.subscribe(event => {
        this.InitControl(event);
      });

    }
    this.comunicationService.receivedFormEvent.subscribe(event => {
      if (event.Action === FormActionsThroughEmitters.Edit) {
        this.InitControl(event);
      }
    });

    if (this.onInitialized.observers.length) {
      setTimeout(() => {

        this.onInitialized.emit(this);
      }, 1000);
    }

  }

  InitControl(event) {
    // Si el evento trae un modelo, verificamos si es el mismo que ya tenemos
    let currentPk = (this._modelo && this._modelo.modelo) ? this._modelo.modelo.PkValue : (this._modelo ? this._modelo.PkValue : null);
    let newPk = (event && event.modelo && event.modelo.modelo) ? event.modelo.modelo.PkValue : (event && event.modelo ? event.modelo.PkValue : null);

    // Solo inicializamos la lista si es un registro de TRD totalmente diferente
    if (currentPk !== newPk || !this.selectedItems || this.selectedItems.length === 0) {
       this.InitList();
    }

    setTimeout(() => {
      this.modelo = event.modelo; 
      this.ValidateSelectionItems();
    }, 100);
  }
  //* END FUNCIONES ANGULAR

  //* FUNCIONES PERSONALIZADAS

  public InitAll(modelo) {

    this.InitList();
    this.SetConfiguracion();
    this.SetModelo(modelo);

  }

  InitList() {
    if (!this.selectedItems) this.selectedItems = [];
    this.selectedItems.length = 0;

    if (!this.deltetedItems) this.deltetedItems = [];
    this.deltetedItems.length = 0;

    if (!this.addItems) this.addItems = [];
    this.addItems.length = 0;
  }

  OnInit() {

    this.SetConfiguracion();

    if (this.loadOnInit == true) {
      this.Load();
    }

  }

  public OnSetConfig() {
    this.listToConnect.push(this.listName);
    if (this.config) {
      this.label = this.config.Label || this.label;
      if (this.config.ConfigControl) {
        if (!this.url)
        if(this.config.ConfigControl.AdminMetadata && this.config.ConfigControl.AdminMetadata.ConfigControl)
        this.url = this.config.ConfigControl.AdminMetadata.ConfigControl.Controller;
        else
          this.url = this.config.ConfigControl.Controller;

        if (this.config.ConfigControl.QueryConfig && this.config.ConfigControl.QueryConfig.Command) {
          this.QueryConfig = this.config.ConfigControl.QueryConfig;

          if (this.config.ConfigControl.QueryConfigSelection && this.config.ConfigControl.QueryConfigSelection.ProcessMessage)
            this.processMessage = this.config.ConfigControl.QueryConfigSelection.ProcessMessage;
        }
      }
      if (this.config.ProcessMessage)
        this.processMessage = this.config.ProcessMessage;

      this.pkField = this.config.PkField || this.pkField;
      this.textField = this.config.TextField || this.textField;
      this.propConfiguracionInterna = this.config.ConfigInternalProp || this.propConfiguracionInterna;
      this.propConfiguracion = this.config.ConfigProp || this.propConfiguracion;
      this.name = this.config.Name || this.name;
    }

    if (!this.name)
      this.name = this.componentName;
    let _config = {
      "Controller": "",
      "ProcessMessage": "",
      "PkField": "Id",
      "ConfigInternalProp": "",
      "ConfigProp": "Configuracion",
      "ConfigControl": {
        "QueryConfig": { "Url": "", "ProcessMessage": "", "Command": "" },
        "QueryConfigSelection": { "Url": "", "ProcessMessage": "", "Command": "" }
      }
    };

  }

  _SetModelo(modeloRecibido: any) {
    if (!modeloRecibido) return;

    let modelo = (modeloRecibido.modelo) ? modeloRecibido.modelo : modeloRecibido;
    let pk = modelo.PkValue || 'NUEVO';
    let claveInterna = (this.propConfiguracionInterna && this.propConfiguracionInterna.trim() !== "") 
        ? this.propConfiguracionInterna 
        : 'Metadatos';

    if (DragAndDopMetadataComponent.CacheMetadatos[pk] && DragAndDopMetadataComponent.CacheMetadatos[pk].length > 0) {
      console.warn("🏦 [BÓVEDA] El padre intentó borrarnos. Restaurando datos desde la memoria global.");
      this.selectedItems = DragAndDopMetadataComponent.CacheMetadatos[pk];
      this._SetConfiguracion(modelo);
      this.ValidateSelectionItems();
      if (this.cdr && !(this.cdr as any).destroyed) this.cdr.detectChanges();
      return;
    }

    let temp;
    const configRaw = modelo[this.propConfiguracion];
    try {
      temp = (typeof configRaw === 'string' && configRaw !== "") ? JSON.parse(configRaw) : (configRaw || {});
    } catch (e) { temp = {}; }

    if (temp[claveInterna] && Array.isArray(temp[claveInterna])) {
      this.selectedItems = temp[claveInterna].map(item => {
        const base = this.allSelectionItems.find(x => x[this.pkField] == item[this.pkField]);
        return base ? { ...base, ...item } : item;
      });
      this.ValidateSelectionItems();
      DragAndDopMetadataComponent.CacheMetadatos[pk] = this.selectedItems;
    } else {
      this.selectedItems = [];
    }

    if (this.cdr && !(this.cdr as any).destroyed) {
      this.cdr.detectChanges();
    }
  }

  public SetModelo(modelo: any) {
    this._modelo = modelo;

    if (this.modelo) {
      if (this.isModelContainer) this._SetModelo(this.modelo.modelo);
      else this._SetModelo(this.modelo);
    } else {
      this.selectedItems = [];
    }
    
    this.ValidateSelectionItems(); 
    this.SetConfiguracion();

    if (this.cdr && !(this.cdr as any).destroyed) {
      try {
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      } catch (e) {
        
      }
    }
  }

  _SetConfiguracion(modeloRecibido: any) {
    if (!modeloRecibido) return;

    let modelo = (modeloRecibido.modelo) ? modeloRecibido.modelo : modeloRecibido;
    let claveInterna = (this.propConfiguracionInterna && this.propConfiguracionInterna.trim() !== "") 
        ? this.propConfiguracionInterna 
        : 'Metadatos';

    let temp;
    try {
      const currentConfig = modelo[this.propConfiguracion];
      temp = (typeof currentConfig === 'string' && currentConfig !== "") 
             ? JSON.parse(currentConfig) 
             : (currentConfig || {});
    } catch (e) {
      temp = {};
    }

    temp[claveInterna] = this.selectedItems;
    let nuevoJson = JSON.stringify(temp);

    if (modelo[this.propConfiguracion] !== nuevoJson) {
      modelo[this.propConfiguracion] = nuevoJson;
      console.warn("🚨 [TRACKER] JSON MUTADO EN EL MODELO:", modelo[this.propConfiguracion]);
    }
  }

  public SetConfiguracion() {

    if (this.modelo) {
      if (this.isModelContainer)
        this._SetConfiguracion(this.modelo.modelo);
      else
        this._SetConfiguracion(this.modelo);
    }

  }

  public ValidateSelectionItems() {

    this.selectionItems = this.utility.Clone(this.allSelectionItems);
    this.selectedItems.forEach((item, index) => {
      let currentIndex = this.selectionItems.findIndex(x => { return x[this.pkField] == item[this.pkField]; })
      if (currentIndex > -1) {
        this.selectionItems.splice(currentIndex, 1);
      }
      else {
        
      }
    })

  }

  RemoveItem(item: any, items: Array<any>) {

    if (this.Disabled)
      return;
    let currentIndex = items.findIndex(x => { return x[this.pkField] == item[this.pkField]; })
    if (currentIndex > -1) {
      items.splice(currentIndex, 1);
    }

  }

  EndAction(item: any, items: Array<any>, actionType: string) {
    this.RemoveItem(item, items);
    this.ValidateSelectionItems();
    this.SetConfiguracion();
    
    this.FireAction(actionType); 
  }

  public Add(item, index) {
    if (this.Disabled)
      return;
    this.selectedItems.push(item);
    this.addItems.push(item);
    this.EndAction(item, this.deltetedItems, 'Add');

  }

  selectField(event: any) {
    if (this.Disabled)
      return;

    this.internalsSelectField({ control: null, index: 0 });
    setTimeout(() => {
      this.internalsSelectField(event);
    }, 50);

  }

  internalsSelectField(event: any) {

    if (event.control && event.control.ControlType == 'GridView') {
      // if (!event.control.Columns)
      //   event.control.Columns = [];
      if (!event.control.ConfigControl)
        event.control.ConfigControl = {
          "Controller": "",
          "Params": {},
          "QueryConfig": {
            "Command": "",
            "IsSp": false,
            "Entity": {},
            "WithPagination": false,
            "OutPutParam": false,
          },
          "NotLoad": false
        };
    }
    this.currentFieldModel = event.control;// this.model.Controls[event.index];
    this.currentIndexFieldModel = event.index;

    if (event.isWindow) {
      this.verProperty(event.index);
    }

  }

  currentIndexFieldModel: any = null;
  currentFieldModel: any = 0;
  verProperty(index): any {
    let config: ConfigWindow = new ConfigWindow();
    config.classWindow = 'info';
    config.titleWindow = "Propiedades";
    config.returnInstance = false;
    config.modal = false;
    config.width = 600;
    config.height = 600;
    config.viewOk = false;
    config.cancel = 'Cerrar';
    let windowModel: any = {
      subControl: this.currentFieldModel,
      subControlIndex: this.currentIndexFieldModel,
      isMetadata: true
    };
    this.utility.OpenWindow('PropertyGridControlsComponent',
      config, windowModel).then(dataResult => {
        // console.log(dataResult);
        dataResult.onClosePromise.then(dataResultOnClose => {
          // console.log(dataResultOnClose);
        });
      })
  }

  public Delete(event) {
    if (this.Disabled)
      return;
    this.selectedItems.splice(event.index, 1);
    this.deltetedItems.push(event.control);
    this.EndAction(event.control, this.addItems, 'Delete');

  }

  FireAction(actionType: string) {
    // 🤫 Silencio absoluto para que el padre no se rompa al recibir eventos
    console.warn("🤫 Silenciando FireAction para proteger al padre de su propio crash.");
  }

  public Load() {
    try {
      if (this.QueryConfig && this.QueryConfig.Command) {
        let obj = this.utility.GetApiModel('Load', '');
        obj.QueryConfig = this.QueryConfig;
        const _url = (this.QueryConfig.Url) ? this.QueryConfig.Url : this.url;
        this.baseService.Get(obj, null, {
            componentName: this.componentName,
            processMessage: this.processMessage,
            method: 'Load'
          }, _url, false, true).then(result => {
            this.allSelectionItems = result.Data.filter(item => item.Activo == true);
            
            // ¡EL CAMBIO! Si ya tenemos un modelo cargado, re-hidratamos ahora que llegó el catálogo
            if (this.selectedItems.length > 0) {
              this.SetModelo(this.modelo);
            }
            
            this.ValidateSelectionItems();
            if (this.cdr) this.cdr.detectChanges();
          }).catch(error => {
            this.utility.logger.LogError(error, obj, { componentName: this.componentName, method: 'Load' });
          })
      } 
      // ... (mantén el resto del Load igual, pero aplica la lógica de re-hidratar en cada .then)
    } catch (error) {
      this.utility.logger.LogError(error, null, { componentName: this.componentName, method: 'Load' });
    }
  }

  //! NO HACE NADA
  dragStart(event: CdkDragStart) {
    // this._currentIndex = this.fieldModels.indexOf(event.source.data); // Get index of dragged type
    // this._currentField = this.child.nativeElement.children[this._currentIndex]; // Store HTML field
  }

  //! NO HACE NADA
  moved(event: CdkDragMove) {
    // Check if stored HTML field is as same as current field
    // if (this.child.nativeElement.children[this._currentIndex] !== this._currentField) {
    //   // Replace current field, basically replaces placeholder with old HTML content
    //   // this.child.nativeElement.replaceChild(this._currentField, this.child.nativeElement.children[this._currentIndex]);
    // }
  }

  itemDropped(event: CdkDragDrop<any[]>) {
    if (this.Disabled) return;

    if (event.previousContainer === event.container) {
      moveItemInArray(this.selectedItems, event.previousIndex, event.currentIndex);
    } else {
      this.Add(event.item.data, event.currentIndex);
    }

    this.SetConfiguracion(); 

    let pk = (this._modelo && this._modelo.modelo) ? this._modelo.modelo.PkValue : (this._modelo ? this._modelo.PkValue : 'NUEVO');
    DragAndDopMetadataComponent.CacheMetadatos[pk] = this.selectedItems;

    // 3. 🤫 Mantenemos al hijo silenciado
    // this.FireAction('Update'); 
  }

  //* END FUNCIONES PERSONALIZADAS

}
